import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function CTA() {
  return <section className="bg-black py-20 md:py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden border-t border-white/5" data-id="element-72" data-mp="1lg9ourjkwavi">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(245,158,11,0.12),transparent_60%)] pointer-events-none" data-id="element-73" data-mp="1zeq3r5rlh7oq" />

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-74" data-mp="16rltal9qg15k">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 1.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-center" data-id="element-75" data-mp="16pslh2ndvavz">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-76" data-mp="j2u668b028zn">
            Comienza Hoy
          </span>

          <h2 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-[1.05] tracking-tight mb-8" data-id="element-77" data-mp="38cogkat9whz3">
            Tu nuevo perfil
            <br data-id="element-78" data-mp="3d4zpg35zre3s" />
            <span className="italic bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-79" data-mp="3d6kcz8tw1ws5">
              te está esperando.
            </span>
          </h2>

          <p className="text-xl md:text-2xl text-white/60 font-light max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-80" data-mp="2khvi3rjfenou">
            Agenda tu diagnóstico gratis y descubre exactamente cómo podemos
            transformar tu crédito en los próximos 120 días.
          </p>

          <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 hover:brightness-110 text-black font-semibold px-8 py-4 rounded-full transition-all text-lg shadow-2xl shadow-amber-500/30 mb-8" data-id="element-81" data-mp="2yg39ljxp0wsm">
            Agenda tu diagnóstico gratis
            <ArrowRight className="h-5 w-5" data-id="element-82" data-mp="2jqdjx38jtnn6" />
          </a>
        </motion.div>
      </div>
    </section>;
}